import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { ReviewForgeElementType } from "../../../forge/review-forge-types";

const reviewElementDbWriteValidatorBase = z.object({
  type: createEnum(ReviewForgeElementType),
});

const semanticTagDbWriteValidatorBase = z.object({
  tagId: zExt.objectId(),
  name: z.string(),
  type: createEnum(ReviewForgeElementType),
  metadata: z.any().optional(),
});

const submittableElementDbWriteValidatorBase =
  reviewElementDbWriteValidatorBase.extend({
    required: z.boolean(),
    tag: semanticTagDbWriteValidatorBase,
  });
const reviewShortAnswerElementDbWriteValidator =
  submittableElementDbWriteValidatorBase.extend({
    type: z.literal(ReviewForgeElementType.SHORT_ANSWER),
    title: z.string(),
    placeholderText: z.string(),
  });

const reviewRichTextElementDbWriteValidator =
  reviewElementDbWriteValidatorBase.extend({
    type: z.literal(ReviewForgeElementType.RICH_TEXT),
    id: z.number(),
    html: z.string(),
    fontFamily: z.string(),
    fontWeight: z.string(),
    fontSizePx: z.number(),
    textColor: z.string(),
    linkColor: z.string(),
  });

const reviewLogoElementDbWriteValidator =
  reviewElementDbWriteValidatorBase.extend({
    type: z.literal(ReviewForgeElementType.LOGO),
    widthPercentage: z.number(),
  });

const reviewProductDetailsElementDbWriteValidator =
  reviewElementDbWriteValidatorBase.extend({
    type: z.literal(ReviewForgeElementType.PRODUCT_DETAILS),
    imageWidthPercentage: z.number(),
    showVariantTitle: z.boolean().optional(),
    preferVariantImage: z.boolean().optional(),
  });

const reviewStarsElementDbWriteValidator =
  submittableElementDbWriteValidatorBase.extend({
    type: z.literal(ReviewForgeElementType.STARS),
    title: z.string(),
  });

const reviewMediaUploadElementDbWriteValidator =
  submittableElementDbWriteValidatorBase.extend({
    type: z.literal(ReviewForgeElementType.MEDIA_UPLOAD),
    widthPercentage: z.number(),
  });

const reviewSingleSelectElementDbWriteValidator =
  submittableElementDbWriteValidatorBase.extend({
    type: z.literal(ReviewForgeElementType.SINGLE_SELECT),
    options: z.array(z.string()),
  });

const reviewParagraphElementDbWriteValidator =
  submittableElementDbWriteValidatorBase.extend({
    type: z.literal(ReviewForgeElementType.PARAGRAPH),
    title: z.string(),
    placeholderText: z.string(),
    required: z.boolean(),
  });

const reviewDiscountElementDbWriteValidator =
  reviewElementDbWriteValidatorBase.extend({
    type: z.literal(ReviewForgeElementType.DISCOUNT),
    discountId: z.string().optional(),
  });

const reviewStaticElementDbWriteValidator = z.discriminatedUnion("type", [
  reviewRichTextElementDbWriteValidator,
  reviewLogoElementDbWriteValidator,
  reviewProductDetailsElementDbWriteValidator,
]);

const reviewSubmittableElementDbWriteValidator = z.discriminatedUnion("type", [
  reviewShortAnswerElementDbWriteValidator,
  reviewStarsElementDbWriteValidator,
  reviewMediaUploadElementDbWriteValidator,
  reviewSingleSelectElementDbWriteValidator,
  reviewParagraphElementDbWriteValidator,
]);

export const reviewElementDbWriteValidator = z.discriminatedUnion("type", [
  ...reviewStaticElementDbWriteValidator._def.options,
  ...reviewSubmittableElementDbWriteValidator._def.options,
  reviewDiscountElementDbWriteValidator,
]);

export const thankYouPageElementDbWriteValidator = z.discriminatedUnion(
  "type",
  [
    ...reviewStaticElementDbWriteValidator._def.options,
    reviewDiscountElementDbWriteValidator,
  ],
);
